import { api as accountingApi } from "../api";
import { CollectionResponse } from "../types";
import { Product, ProductGetParams, ProductSearchParams } from "./types";

export const productsApi = accountingApi.injectEndpoints({
    endpoints: (build) => ({
        getProducts: build.query<CollectionResponse<Product>, ProductSearchParams>({
            query: ({ accountId, ...params }) => ({
                url: `api/v1/accounting/${accountId}/products`,
                params,
            }),
        }),
        getProduct: build.query<Product, ProductGetParams>({
            query: ({ accountId, productId }) => ({
                url: `api/v1/accounting/${accountId}/products/${productId}`,
            }),
        }),
    }),
});

export const { useGetProductsQuery, useGetProductQuery } = productsApi;
